"use client";
import React from "react";
import Lottie from "lottie-react";
import defaultAnimation from "@/../public/assets/animation/TimeAnimation.json";
import { TextShimmer } from "./text-shimmer";

interface LoadingProps {
  animationData?: any;
}

const Loading: React.FC<LoadingProps> = () => {
  return (
    <div className="fixed w-screen h-screen top-0 left-0 flex justify-center items-center bg-zinc-950/70 z-50 opacity-65">
      <TextShimmer className="font-mono text-lg" duration={1}>
        Loading...
      </TextShimmer>
    </div>
  );
};

export default Loading;
